import React, { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@radix-ui/react-avatar";
import { Button } from "../ui/button";
import userService from "../../services/userService";
import useAuthStore from "../../store/authStore";

export default function AvatarForm() {
  const { user , refetchUser} = useAuthStore();
  const [avatarUrl, setAvatarUrl] = useState(user.avatar_url || "https://github.com/shadcn.png"); // URL ảnh đại diện ban đầu
  const [tempAvatarUrl, setTempAvatarUrl] = useState(null); // URL ảnh tạm thời để xem trước
  const [file, setFile] = useState(null); // File ảnh để tải lên
  const [loading, setLoading] = useState(false); // Trạng thái tải lên

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); // Lưu file để tải lên sau
      setTempAvatarUrl(URL.createObjectURL(selectedFile)); // Tạo URL xem trước từ file
    }
  };

  const handleAvatarUpdate = async () => {
    if (!file) return;

    setLoading(true);

    try {
      const response = await userService.updateAvatar(file);

      if (response.error) {
        console.error("Cập nhật avatar thất bại:", response.error);
      } else {
        console.log("Avatar cập nhật thành công:", response.data);
        setAvatarUrl(response.data.avatar_url); // Cập nhật URL ảnh chính thức
        setTempAvatarUrl(null); // Xóa URL ảnh tạm thời
        setFile(null); // Xóa file đã chọn
        refetchUser()
      }
    } catch (error) {
      console.error("Có lỗi xảy ra:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setTempAvatarUrl(null); // Hủy ảnh xem trước
    setFile(null); // Xóa file đã chọn
  };

  return (
    <div className="space-y-16">
      <div>
        <h1 className="text-center text-xl font-[Phudu] font-bold">Ảnh đại diện</h1>
        <p className="text-center text-md font-normal">Thay đổi ảnh đại diện tại đây</p>
      </div>
      <div className="flex flex-col items-center justify-center gap-8">
        <div>
          <Avatar className="cursor-pointer">
            <AvatarImage
              src={tempAvatarUrl || avatarUrl} // Hiển thị ảnh tạm thời nếu có
              alt="Avatar"
              className="rounded-full size-32"
            />
            <AvatarFallback>CN</AvatarFallback>
          </Avatar>
        </div>
        <div className="flex gap-4">
          <Button className="rounded-full" disabled={loading}>
            <label htmlFor="file-upload" className="cursor-pointer">
              {loading ? "Đang tải lên..." : "Chọn ảnh"}
            </label>
            <input
              id="file-upload"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
            />
          </Button>
          {tempAvatarUrl && (
            <>
              <Button
                onClick={handleAvatarUpdate}
                className="rounded-full bg-green-400"
                disabled={loading}
              >
                Xác nhận
              </Button>
              <Button
                onClick={handleCancel}
                className="rounded-full"
                variant="secondary"
              >
                Hủy
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
